import * as Yup from 'yup'

import { SignerFullnameLength, signerFullnameRegexp } from '@const/consts'
import { SignerValidation, Warning } from '@const/translations'

const fullNameRegexp = new RegExp(
  signerFullnameRegexp.source,
  signerFullnameRegexp.flags.replace('g', ''),
)

export const fullNameValidationSchema = Yup.object().shape({
  fullName: Yup.string()
    .trim()
    .max(SignerFullnameLength.MAX, Warning.max[SignerFullnameLength.MAX])
    .matches(fullNameRegexp, {
      message: SignerValidation.fullName,
      excludeEmptyString: true,
    })
    .required(Warning.required),
})
